import React from "react";
import ChartItem from "./ChartItem";
import { adaptDataPieChart, buildDataArray, getSum } from "./utils";
import withTheme from "../../../hocs/withTheme";
import "highcharts/css/highcharts.css";
import "./PieChart.css";

function PieChart({
    data = [],
    numberFormat = (num) =>
        num.toLocaleString("en-US", { minimumFractionDigits: 2 }),
    percentFormat = (num) =>
        `${num.toLocaleString("en-US", { maximumFractionDigits: 2 })}`,
    disableLegend = false,
    hideValues = false,
    chartSize,
    showCHFValue = false
}) {
    return (
        <div className={`PieChart`}>
            <ChartItem
                sum={getSum(adaptDataPieChart(data, 8))}
                data={buildDataArray(adaptDataPieChart(data, 8))}
                numberFormat={numberFormat}
                percentFormat={percentFormat}
                disableLegend={disableLegend}
                hideValues={hideValues}
                chartSize={chartSize}
                showCHFValue={showCHFValue}
            />
        </div>
    );
}


export default withTheme(PieChart);
